import { pageLimit } from "../Utils/helper";
import { apiInstance } from "./ApiInstance";

export const postBlacklistCases = async (type, payload) => {
  let { data = {} } = await apiInstance.post(
    `de-empanel/${type}-blacklist`,
    payload
  );
  return data;
};

export const getHospitalList = async (type, query) => {
  let { data = {} } = await apiInstance.get(
    `/de-empanel/${type}-list?limit=${pageLimit}&${query}`
  );
  return data;
};

export const getRlmuData = async (caseId) => {
  let { data = {} } = await apiInstance.get(`/de-empanel/rlmu-data/${caseId}`);
  return data;
};
